import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, normalizeClass as _normalizeClass, resolveComponent as _resolveComponent, createBlock as _createBlock } from "vue";
import _imports_0 from '@/assets/images/voting-presents.png';
import _imports_1 from '@/assets/images/eth_address.webp';
const _hoisted_1 = {
  key: 0,
  class: "banner bg-cover-bottom has-shapes has-bg-brash bg-brash-bottom aos-init aos-animate",
  "data-aos": "fade-in",
  "data-aos-delay": "150"
};
const _hoisted_2 = {
  class: "container"
};
const _hoisted_3 = {
  class: "row justify-content-center align-items-center"
};
const _hoisted_4 = {
  class: "col-lg-8 col-md-9 text-left"
};
const _hoisted_5 = {
  class: "section-title fw-extra-bold fs-50"
};
const _hoisted_6 = {
  class: "section-title fw-extra-bold"
};
const _hoisted_7 = /*#__PURE__*/_createElementVNode("div", {
  class: "col-lg-4"
}, [/*#__PURE__*/_createElementVNode("img", {
  src: _imports_0,
  alt: ""
})], -1);
const _hoisted_8 = {
  class: "banner bg-cover-bottom has-shapes bg-white",
  "data-aos": "fade-in",
  "data-aos-delay": "150"
};
const _hoisted_9 = {
  key: 0,
  class: "container"
};
const _hoisted_10 = {
  class: "mb-4"
};
const _hoisted_11 = {
  class: "fw-bold"
};
const _hoisted_12 = {
  class: "tabs-navbar"
};
const _hoisted_13 = {
  class: "nav nav-tabs mb-3",
  id: "pills-tab-top",
  role: "tablist"
};
const _hoisted_14 = ["onClick"];
const _hoisted_15 = {
  class: "nav nav-pills mb-3 mt-4",
  id: "pills-tab",
  role: "tablist"
};
const _hoisted_16 = ["onClick"];
const _hoisted_17 = {
  class: "tab-content colored-icon-box",
  id: "pills-tabContent"
};
const _hoisted_18 = {
  class: "tab-pane fade show active",
  id: "pills-home",
  role: "tabpanel"
};
const _hoisted_19 = ["onClick"];
const _hoisted_20 = {
  class: "bg-white rounded p-20 icon-box",
  style: {
    "cursor": "pointer",
    "box-shadow": "0px 4px 24px 0px rgb(16 27 82 / 8%)"
  }
};
const _hoisted_21 = {
  class: "card-body"
};
const _hoisted_22 = {
  class: "row justify-content-between align-items-center mb-2"
};
const _hoisted_23 = {
  class: "col-10 row m-0 align-items-center align-content-center"
};
const _hoisted_24 = /*#__PURE__*/_createElementVNode("div", {
  class: "mr-1"
}, [/*#__PURE__*/_createElementVNode("img", {
  src: _imports_1,
  class: "rounded-circle shadow",
  style: {
    "width": "20px"
  },
  alt: ""
})], -1);
const _hoisted_25 = {
  class: "pt-1"
};
const _hoisted_26 = {
  class: "col-2 text-right"
};
const _hoisted_27 = {
  class: "row mb-2"
};
const _hoisted_28 = {
  class: "col-12 font-weight-bold"
};
const _hoisted_29 = {
  class: "row m-0 mb-2"
};
const _hoisted_30 = {
  class: "mt-4"
};
const _hoisted_31 = {
  type: "button",
  class: "btn btn-primary btn-sm"
};
export function render(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_loading = _resolveComponent("loading");
  const _component_empty = _resolveComponent("empty");
  return _openBlock(), _createElementBlock("div", null, [!$data.detail.show ? (_openBlock(), _createElementBlock("section", _hoisted_1, [_createElementVNode("div", _hoisted_2, [_createElementVNode("div", _hoisted_3, [_createElementVNode("div", _hoisted_4, [_createElementVNode("h1", _hoisted_5, _toDisplayString(_ctx.$t('vote.toupiao')), 1), _createElementVNode("h2", _hoisted_6, _toDisplayString(_ctx.$t('vote.title')), 1)]), _hoisted_7])])])) : _createCommentVNode("", true), _createElementVNode("section", _hoisted_8, [!$data.detail.show ? (_openBlock(), _createElementBlock("div", _hoisted_9, [_createElementVNode("div", _hoisted_10, [_createElementVNode("h2", _hoisted_11, _toDisplayString(_ctx.$t('vote.proposal')), 1)]), _createElementVNode("div", null, [_createElementVNode("div", _hoisted_12, [_createElementVNode("ul", _hoisted_13, [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList($data.type, t => {
    return _openBlock(), _createElementBlock("li", {
      class: "nav-item mr-2 fw-medium",
      role: "presentation",
      key: t.value,
      onClick: $event => $options.checkType(t.value)
    }, [_createElementVNode("a", {
      class: _normalizeClass(["nav-link cursor-pointer", t.value === $data.check.type ? 'active' : '']),
      role: "tab",
      "aria-controls": "pills-home"
    }, _toDisplayString(t.label), 3)], 8, _hoisted_14);
  }), 128))])]), _createElementVNode("ul", _hoisted_15, [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList($data.state, s => {
    return _openBlock(), _createElementBlock("li", {
      class: "nav-item mr-2",
      role: "presentation",
      key: s.value,
      onClick: $event => $options.checkState(s.value)
    }, [_createElementVNode("a", {
      class: _normalizeClass(["nav-link cursor-pointer", s.value === $data.check.status ? 'active' : '']),
      role: "tab",
      "aria-controls": "pills-home"
    }, _toDisplayString(s.label), 3)], 8, _hoisted_16);
  }), 128))]), _createElementVNode("div", _hoisted_17, [_createElementVNode("div", _hoisted_18, [$data.loading ? (_openBlock(), _createBlock(_component_loading, {
    key: 0
  })) : _createCommentVNode("", true), !$data.loading ? (_openBlock(), _createElementBlock(_Fragment, {
    key: 1
  }, [!$options.proposalData.records || $options.proposalData.records.length === 0 ? (_openBlock(), _createBlock(_component_empty, {
    key: 0
  })) : _createCommentVNode("", true), (_openBlock(true), _createElementBlock(_Fragment, null, _renderList($options.proposalData.records, (proposal, index) => {
    return _openBlock(), _createElementBlock("div", {
      class: "mb-4",
      "data-aos": "fade-up",
      onClick: $event => $options.showDetail(proposal),
      "data-aos-delay": "50",
      key: index
    }, [_createElementVNode("div", _hoisted_20, [_createElementVNode("div", _hoisted_21, [_createElementVNode("div", _hoisted_22, [_createElementVNode("div", _hoisted_23, [_hoisted_24, _createElementVNode("span", _hoisted_25, _toDisplayString(proposal.author), 1)]), _createElementVNode("div", _hoisted_26, [_createElementVNode("span", {
      class: _normalizeClass(["badge badge-pill", $data.proposalStatusMap[proposal.proposalStatus].className])
    }, _toDisplayString($data.proposalStatusMap[proposal.proposalStatus].label), 3)])]), _createElementVNode("div", _hoisted_27, [_createElementVNode("h4", _hoisted_28, _toDisplayString(proposal.title), 1)]), _createElementVNode("div", _hoisted_29, [_createElementVNode("p", null, _toDisplayString(proposal.body), 1)]), _createElementVNode("div", _hoisted_30, [_createElementVNode("button", _hoisted_31, _toDisplayString(_ctx.$t('vote.chakanxiangqing')), 1)])])])], 8, _hoisted_19);
  }), 128))], 64)) : _createCommentVNode("", true)])])])])) : _createCommentVNode("", true)])]);
}